<template>
  <div ref="component"></div>
</template>

<script>
  export default {
    props: {
      keepFixed: {
        default: ''
      },
      saveOrderTo: {
        default: ''
      },
    },
    name: 'Random',
    data() {
      return {}
    },
    mounted() {
      const vueComponent = $(this.$refs.component);
      const keepFixed = (this.keepFixed ? this.keepFixed : '')
        .split(',')
        .map(element => element.trim())
        .filter(element => element !== '');
      const saveOrderTo = this.saveOrderTo;
      const vue = this;

      $(function () {
        const questionContainer = vueComponent.closest('.question-container');
        console.log({questionContainer});

        return handleSingleRadioOptions(questionContainer) ||
          handleSingleCheckboxOptions(questionContainer);
      });

      function handleSingleRadioOptions(questionContainer) {
        const answersList = $('.answers-list', questionContainer);
        if (answersList.length === 0)
          return false;

        console.log('SingleRadioOptions');
        console.log({answersList});
        const allAnswers = [];
        $('.answer-item', answersList).each(function () {
          const element = $(this);
          const code = element.find('input').val();
          if (code && $.inArray(code, keepFixed) === -1)
            allAnswers.push(element);
        });
        console.log({allAnswers});
        const randomisedAnswers = allAnswers.sort(vue.randomOrder);
        console.log({randomisedAnswers});
        randomisedAnswers.forEach(answer => {
          answer.prependTo(answersList);
        });

        if (saveOrderTo) {
          const codes = [];
          $('.answer-item', answersList).each(function () {
            codes.push($(this).find('input').val());
          });
          vue.saveOrder(codes, saveOrderTo);
        }

        return true;
      }

      function handleSingleCheckboxOptions(questionContainer) {
        const answersList = $('.multiple-choice-container.questions-list', questionContainer);
        if (answersList.length === 0)
          return false;

        console.log('SingleCheckboxOptions');
        console.log({answersList});
        const allAnswers = [];
        $('> .col-sm-12', answersList).each(function () {
          const element = $(this);
          const code = element.find('input.checkbox').data('value');
          if (code && $.inArray(code, keepFixed) === -1)
            allAnswers.push(element);
        });
        console.log({allAnswers});
        const randomisedAnswers = allAnswers.sort(vue.randomOrder);
        console.log({randomisedAnswers});
        randomisedAnswers.forEach(answer => {
          answer.prependTo(answersList);
        });

        if (saveOrderTo) {
          const codes = [];
          $('> .col-sm-12', answersList).each(function () {
            codes.push($(this).find('input.checkbox').data('value'));
          });
          vue.saveOrder(codes, saveOrderTo);
        }

        return true;
      }
    },
    methods: {
      randomOrder() {
        return (Math.round(Math.random()) - 0.5);
      },
      saveOrder(codes, saveOrderTo) {
        console.log({codes: codes.join(', ')});
        codes = codes.filter(code => code !== '');
        $('[data-question-code="' + saveOrderTo + '"]')
          .addClass('hide-question')
          .find('.form-control')
          .val(codes.join(', '));
      }
    }
  }
</script>
